import { z } from "zod";
import { P as ProductName, h as PaymentFrequency, i as ProductPerk } from "./enums-C8iMtmI9.js";
const offerSchema = z.object({
  id: z.number().nullable(),
  currency: z.string().nullable().optional(),
  // Marked native enum to document the type, it is relaxed to string because offers may change dynamically
  name: z.nativeEnum(ProductName).or(z.string()),
  displayName: z.string().optional(),
  paymentFrequency: z.nativeEnum(PaymentFrequency).nullable(),
  prices: z.record(
    z.string(),
    z.object({
      code: z.string(),
      symbol: z.string().optional(),
      label: z.string().optional(),
      price: z.any().pipe(z.coerce.number()),
      discountedPrice: z.any().pipe(z.coerce.number()).nullable().optional(),
      discountValue: z.any().pipe(z.coerce.number()).nullable().optional()
    })
  ),
  productPerks: z.array(
    z.object({
      config: z.record(z.string(), z.any()),
      credits: z.number(),
      unlimited: z.boolean(),
      // Marked native enum to document the type, it is relaxed to string because offers may change dynamically
      type: z.nativeEnum(ProductPerk).or(z.string())
    })
  ).nullable().optional().default([])
});
const fetchOffersResponseSchema = z.object({
  canBuyPlus: z.boolean(),
  offers: z.array(offerSchema),
  renewOffers: z.array(offerSchema),
  upgradeOffers: z.array(offerSchema)
});
const fetchOffersRequestSchema = z.object({
  renew: z.boolean().optional().default(false),
  upgrade: z.boolean().optional().default(false),
  channel: z.string().optional()
});
function makeFetchOffersRoute({
  baseUrl = "",
  renew = false,
  upgrade = false,
  channel = ""
} = {}) {
  return `${baseUrl}/api/v2/offers?renew=${renew}&upgrade=${upgrade}&channel=${channel}`;
}
function fetchOffers({
  client,
  params = { renew: false, upgrade: false, channel: "" }
}) {
  const { renew, upgrade, channel } = fetchOffersRequestSchema.parse(params);
  return client.get(makeFetchOffersRoute({ renew, upgrade, channel })).valid(fetchOffersResponseSchema);
}
export {
  fetchOffersRequestSchema as a,
  fetchOffers as b,
  fetchOffersResponseSchema as f,
  makeFetchOffersRoute as m,
  offerSchema as o
};
//# sourceMappingURL=fetch-offers-Dxzm5j4P.js.map
